import { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import _ from 'lodash';

import BreadCrumb from '../../../Components/Common/BreadCrumb';

import GeneralInfo from './components/GeneralInfo';
import { getAuditById } from '../../../slices/audits/thunk';
import JsonViewer from './components/JsonViewer';

const AuditManagementDetails = (props) => {
  const dispatch = useDispatch();
  const { auditId } = useParams();

  useEffect(() => {
    dispatch(getAuditById(auditId));
  }, [dispatch, auditId]);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={`${props.t('audit')}`} pageTitle={props.t('audit')} showBackButton />
        </Container>

        <Row className="w-100 mx-auto gx-4 gx-md-5">
          <Col xl={3} className="order-2 order-xl-1 mt-5 mt-xl-0">
            <GeneralInfo />
          </Col>

          <Col xl={9} className="order-1 order-xl-2">
            <JsonViewer />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default withTranslation()(AuditManagementDetails);
